import React, { useState, useRef } from "react";
import "./WorksGallery.css";

export default function WorksGalleryPage() {

  /* =====================================================
     IMAGES
  ===================================================== */

  const images = [
    { src: "/images/1.jpeg", title: "" },
    { src: "/images/6.png", title: "" },
    { src: "/images/9.jpeg", title: "" },
    { src: "/images/12.png", title: "" },
    { src: "/images/13.jpeg", title: "" },
    { src: "/images/20.jpeg", title: "" },
    { src: "/images/23.jpeg", title: "" },
    { src: "/images/24.jpeg", title: "" },
    { src: "/images/31.jpeg", title: "" },
    { src: "/images/32.jpeg", title: "" },
    { src: "/images/33.png", title: "" },
    { src: "/images/37.jpeg", title: "" },
    { src: "/images/38.jpeg", title: "" },
    { src: "/images/43.jpeg", title: "" },

  ];


  /* =====================================================
     VIDEOS
  ===================================================== */

  const videos = [
    {
      src: "/video/1.mp4",
    },

    {
      src: "/video/8.mp4",
    },

    {
      src: "/video/14.mp4",
    },


    {
      src: "/video/22.mp4",
    },

    {
      src: "/video/25.mp4",
    },

  ];


  /* =====================================================
     STATES
  ===================================================== */

  const [currentIndex, setCurrentIndex] = useState(null);
  const [zoom, setZoom] = useState(1);

  const startX = useRef(0);


  /* =====================================================
     OPEN IMAGE
  ===================================================== */

  const openImage = (index) => {
    setCurrentIndex(index);
    setZoom(1);
  };


  /* =====================================================
     CLOSE MODAL
  ===================================================== */

  const closeModal = () => {
    setCurrentIndex(null);
    setZoom(1);
  };


  /* =====================================================
     NEXT IMAGE
  ===================================================== */

  const next = (e) => {

    if (e) {
      e.stopPropagation();
    }

    setCurrentIndex((prev) => {

      if (prev === null) {
        return 0;
      }

      return (prev + 1) % images.length;

    });

    setZoom(1);
  };


  /* =====================================================
     PREVIOUS IMAGE
  ===================================================== */

  const prev = (e) => {

    if (e) {
      e.stopPropagation();
    }

    setCurrentIndex((prev) => {

      if (prev === null) {
        return 0;
      }

      return prev === 0
        ? images.length - 1
        : prev - 1;

    });

    setZoom(1);
  };


  /* =====================================================
     SWIPE
  ===================================================== */

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };


  const handleTouchEnd = (e) => {

    const diff =
      startX.current -
      e.changedTouches[0].clientX;

    if (Math.abs(diff) > 50) {

      if (diff > 0) {
        next();
      } else {
        prev();
      }

    }
  };


  /* =====================================================
     ZOOM
  ===================================================== */

  const handleWheel = (e) => {

    e.preventDefault();

    setZoom((prevZoom) => {

      let newZoom =
        prevZoom +
        (e.deltaY < 0 ? 0.1 : -0.1);

      newZoom = Math.min(
        Math.max(newZoom, 1),
        3
      );

      return newZoom;

    });
  };


  /* =====================================================
     CURRENT IMAGE
  ===================================================== */

  const current =
    currentIndex !== null
      ? images[currentIndex]
      : null;


  return (

    <div className="WorksGallery-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="WorksGallery-hero">

        <div className="WorksGallery-overlay">

          <h1>
            גלריית עבודות
          </h1>

        </div>

      </div>


      {/* =====================================================
          GALLERY
      ===================================================== */}

      <div className="page1">

        <div className="grid">

          {images.map((img, index) => (

            <div
              key={index}
              className="cardd"
              onClick={() => openImage(index)}
            >

              <img
                src={img.src}
                alt={`עבודות הרמה ומנוף ש.מ הובלות ומנופים ${index + 1}`}
                className="img"
              />

              <div className="overlay">

                {img.title && (
                  <h3>
                    {img.title}
                  </h3>
                )}

              </div>

            </div>

          ))}

        </div>


        {/* =====================================================
            VIDEOS
        ===================================================== */}

        <div className="gallery-videos">

          <div className="videos-grid">

            {videos.map((video, index) => (

              <div
                className="video-card"
                key={index}
              >

                <div className="video-wrapper">

                  <video
                    className="gallery-video"
                    controls
                    controlsList="nodownload"
                    disablePictureInPicture
                    playsInline
                    preload="metadata"
                    onContextMenu={(e) =>
                      e.preventDefault()
                    }
                  >

                    <source
                      src={video.src}
                      type="video/mp4"
                    />

                    הדפדפן שלך אינו תומך בניגון וידאו.

                  </video>

                </div>

              </div>

            ))}

          </div>

        </div>

      </div>


      {/* =====================================================
          IMAGE MODAL
      ===================================================== */}

      {currentIndex !== null && current && (

        <div
          className="modal"
          onClick={closeModal}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >

          {/* CLOSE */}

          <button
            type="button"
            className="gallery-close"
            onClick={(e) => {

              e.stopPropagation();
              closeModal();

            }}
            aria-label="סגירת תמונה"
          >
            ×
          </button>


          {/* LEFT */}

          <button
            type="button"
            className="navv left"
            onClick={prev}
            aria-label="תמונה קודמת"
          >
            ‹
          </button>


          {/* RIGHT */}

          <button
            type="button"
            className="navv right"
            onClick={next}
            aria-label="תמונה הבאה"
          >
            ›
          </button>


          {/* IMAGE */}

          <div
            className="modal-box"
            onClick={(e) => {
              e.stopPropagation();
            }}
            onWheel={handleWheel}
          >

            <img
              src={current.src}
              alt={`עבודות הרמה ומנוף ש.מ הובלות ומנופים ${currentIndex + 1}`}
              className="modal-img"
              style={{
                transform: `scale(${zoom})`,
              }}
            />

            {current.title && (

              <div className="modal-text">

                <h2>
                  {current.title}
                </h2>

              </div>

            )}

          </div>

        </div>

      )}

    </div>

  );
}
